var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHamburgerMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 11,
    viewBox: "0 0 19 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.28223 2.50781C0.842773 2.50781 0.491211 2.13867 0.491211 1.70801C0.491211 1.26855 0.842773 0.916992 1.28223 0.916992H17.709C18.1484 0.916992 18.5088 1.26855 18.5088 1.70801C18.5088 2.14746 18.1484 2.50781 17.709 2.50781H1.28223ZM1.28223 6.46289C0.842773 6.46289 0.491211 6.10254 0.491211 5.67188C0.491211 5.22363 0.842773 4.86328 1.28223 4.86328H17.709C18.1484 4.86328 18.5088 5.22363 18.5088 5.67188C18.5088 6.10254 18.1484 6.46289 17.709 6.46289H1.28223ZM1.28223 10.4268C0.842773 10.4268 0.491211 10.0576 0.491211 9.61816C0.491211 9.1875 0.842773 8.82715 1.28223 8.82715H17.709C18.1484 8.82715 18.5088 9.17871 18.5088 9.61816C18.5088 10.0664 18.1484 10.4268 17.709 10.4268H1.28223Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerMenu);
export default __webpack_public_path__ + "static/media/hamburgerMenu.7c778f70778d406144458b7192f45dfb.svg";
export { ForwardRef as ReactComponent };